import { Identifier } from 'types/utilityTypes';

export enum NoteTypes {
  Workout = 'Workout',
  Assessment = 'Assessment',
  Visit = 'Visit',
}

export interface Note {
  id: Identifier;
  createdAt: Date;
  updatedAt: Date;
  userId: Identifier | undefined;
  notableId: Identifier | undefined;
  notableType: string | undefined;
  date: Date;
  notes: string | undefined;
  title: string | undefined;
  createdById: Identifier | undefined;
  image?: {
    url: string;
    thumbUrl: string;
    mediumUrl: string;
    filename: string;
    contentType: string;
    byteSize: number;
  } | null;
}

export interface NoteFilters {
  startDate?: Date | null;
  endDate?: Date | null;
  types?: NoteTypes[] | null;
}
